import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from "../../services/login.service"

@Component({
  selector: "forbidden-page",
  templateUrl: "./forbidden.component.html",
  styleUrls: ["./forbidden.component.scss"]
})
export class ForbiddenComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  permissionExist = false;
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) { }
  message;
  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((queryParams: any) => {
      this.message = queryParams.message;
    });
  }

  logout() {
    // 666
    this.loginService.logOut();
    // 666 ends
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}